// extracted by mini-css-extract-plugin
module.exports = {"logoText":"LogoText_logoText__18am3","logoSecondPart":"LogoText_logoSecondPart__28SUv"};